import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  EdhProtocolAttributePageContext,
  EdhProtocolAttributePageInitialState,
} from ".";

export const EdhProtocolAttributePageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    EdhProtocolAttributePageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <EdhProtocolAttributePageContext.Provider value={context}>
      {children}
    </EdhProtocolAttributePageContext.Provider>
  );
};
